<template>
    <v-dialog v-model="dialog" persistent max-width="500px">
      <v-btn slot="activator" icon>
        <v-icon >add</v-icon>
      </v-btn>
      <v-card>
        <v-toolbar card dark color="primary">
          <v-toolbar-title>Novo Projeto</v-toolbar-title>
        </v-toolbar>
        <v-card-title>
          {{numero}}
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
                <v-flex xs12>
              <v-text-field
                id="codigo"
                name="codigo"
                label="Código"
                v-model="codigo"
                required></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                id="curso"
                name="curso"
                label="Curso"
                v-model="curso"
                required></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                id="faculdade"
                name="faculdade"
                label="Faculdade"
                v-model="faculdade"
                required></v-text-field>
            </v-flex>
              
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click.native="dialog = false">Close</v-btn>
          <v-btn color="blue darken-1" flat @click.native="criarProjeto">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
export default {
  name: "ProjetoCriar",
  data() {
    return {
      dialog: false,
      codigo: "",
      curso: "",
      faculdade: ""
    };
  },
  props: {
    numero: {
      type: String,
      required: true
    }
  },
  methods: {
    criarProjeto() {
      let updates = {};
      updates["/projetos/" + this.numero + "/codigo"] = this.codigo;
      updates["/projetos/" + this.numero + "/curso"] = this.curso;
      updates["/projetos/" + this.numero + "/faculdade"] = this.faculdade;
      this.$db.ref().update(updates);
      this.dialog = false;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/ProjetoCriar.vue